import { useEffect, useMemo, useState } from "react";
import { listClinicalFormsForAdmissionApi } from "../services/clinicalForms.services";
import { admissionQuery } from "../components/PatientsIP/ClinicalPractitioner/admissionContext";
import { isIaForm, isReviewForm } from "../mappers/clinicalForms.mappers";

const sortByIdAsc = (forms) =>
  [...(forms || [])].sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0));

export const getIaForm = (forms) =>
  (forms || []).find((f) => isIaForm(f)) || null;

export const getReviewForm = (forms) =>
  (forms || []).find((f) => isReviewForm(f)) || null;

export const getOtherForms = (forms) => {
  const ia = getIaForm(forms);
  const review = getReviewForm(forms);
  return (forms || []).filter((f) => f !== ia && f !== review);
};

export { sortByIdAsc };

const useClinicalRoleForms = (admissionId, admissionType) => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!admissionId) {
      setForms([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await listClinicalFormsForAdmissionApi(
          admissionQuery(admissionType, admissionId)
        );
        if (cancelled) return;
        setForms(sortByIdAsc(res?.data));
      } catch (e) {
        if (!cancelled)
          setError(e?.response?.data?.detail || "Failed to load forms");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [admissionId, admissionType]);

  return useMemo(
    () => ({
      forms,
      loading,
      error,
      iaForm: getIaForm(forms),
      reviewForm: getReviewForm(forms),
      otherForms: getOtherForms(forms),
    }),
    [forms, loading, error]
  );
};

export default useClinicalRoleForms;
